/*
This script loads more posts when clicking the "Load More" button.
It replaces the pagination with a button that fetches the next page.
*/

let link;

// Fetch and parse next page
async function getNextPage(url) {
    try {
        const res = await fetch(url);

        if (!res.ok) {
            throw new Error('Failed to fetch page')
        }

        const nextPageHtml = await res.text();
        const parser = new DOMParser();
        const parsed = parser.parseFromString(nextPageHtml, 'text/html');
        const posts = parsed.querySelectorAll('.card');
        const nextLink = parsed.querySelector('link[rel="next"]')?.getAttribute('href');

        return {posts, nextLink}

    } catch (error) {
        throw new Error(error)
    }
}

export default function infiniteScroll() {

    // Initialize link after DOM is ready
    link = document.querySelector('link[rel="next"]')?.getAttribute('href');

    const container = document.querySelector('.postfeed-list');
    const pagination = document.querySelector('.pagination');

    console.log('infiniteScroll init:', {link, container, pagination});

    if (!link || !container) {
        return;
    }

    console.log('Creating load more button...');

    // Create load more button
    const loadMoreBtn = document.createElement('button');
    loadMoreBtn.className = 'load-more-btn';
    loadMoreBtn.textContent = 'Mehr laden';

    // Replace pagination content with button
    if (pagination) {
        console.log('Replacing pagination content');
        pagination.innerHTML = '';
        pagination.appendChild(loadMoreBtn);
    } else {
        // If no pagination exists, create wrapper
        console.log('Creating new pagination wrapper');
        const paginationWrapper = document.createElement('nav');
        paginationWrapper.className = 'pagination';
        paginationWrapper.appendChild(loadMoreBtn);
        container.parentElement.appendChild(paginationWrapper);
    }

    const paginationElement = pagination || document.querySelector('.pagination');
    console.log('Button added to pagination');

    // Handle button click
    loadMoreBtn.addEventListener('click', async () => {
        if (!link) return;

        loadMoreBtn.disabled = true;
        loadMoreBtn.textContent = 'Lädt...';

        try {
            const {posts, nextLink} = await getNextPage(link);

            posts.forEach(post => {
                container.append(post);
            });

            if (nextLink) {
                link = nextLink;
                loadMoreBtn.disabled = false;
                loadMoreBtn.textContent = 'Mehr laden';
            } else {
                paginationElement.remove();
            }
        } catch (error) {
            console.error(error);
            loadMoreBtn.disabled = false;
            loadMoreBtn.textContent = 'Fehler - Erneut versuchen';
        }
    });

}